export enum ProductIds {
    HealthEssentials = 5,
    CancerNavigator = 6,
    HealthTracker = 7,
    HealthEssentials2 = 8,
}

/** True when the member has legacy Health Essentials or Health Essentials 2 (HE2). */
export function memberHasHealthEssentialsProduct(productUuid: number): boolean {
    return productUuid === ProductIds.HealthEssentials || productUuid === ProductIds.HealthEssentials2;
}